import spacetime from 'spacetime';

export const sessionsNoOverlap = (sessions: { start: Date; end: Date }[]) =>
  !sessions.some((session, i) => {
    const start = spacetime(session.start);
    const end = spacetime(session.end);
    return sessions.some((innerSession, j) => {
      if (i === j) return false;
      const { start: innerStart, end: innerEnd } = innerSession;
      return (
        start.isBetween(innerStart, innerEnd) ||
        end.isBetween(innerStart, innerEnd)
      );
    });
  });
